import CityPageTemplate from "../city-template/CityPageTemplate";
import { houstonConfig } from "./data";

export default function HoustonPage() {
  return <CityPageTemplate config={houstonConfig} />;
}